<template>
  <v-container fluid class="loginless-layout">
    <v-layout row wrap>
      <v-flex xs12 md3 offset-md5>
        <v-card>
          <v-toolbar class="indigo" dark>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
          </v-toolbar>
          <v-card-media v-if="!!$slots['media']">
            <slot name="media" />
          </v-card-media>
          <v-card-text>
            <slot />
          </v-card-text>
          <v-card-actions v-if="!!$slots['actions']">
            <slot name="actions" />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// LoginlessLayout.vue?59f44434